import type { FetchQueryOptions } from '@tanstack/react-query';
import { patientCardQuery } from '../hooks/patientCardQuery';
import { patientNotesQuery } from '../hooks/patientNotesQuery';
import { patientTimelineQuery } from '../hooks/patientTimelineQuery';
import { patientIdFromPagePath } from './patientPagePath';

// Same keys and fetchers as the hooks PatientFiles mounts, so they reuse these results.
export function patientPagePrefetches(pathname: string): FetchQueryOptions[] {
    const patientId = patientIdFromPagePath(pathname);
    if (!patientId) return [];
    return [
        patientCardQuery(patientId),
        patientNotesQuery(patientId),
        patientTimelineQuery(patientId)
    ];
}
